// extracted by mini-css-extract-plugin
export default {"modalTitle":"iOlo3XqWTgPBwbip6Msc","quotaName":"UL3LEDBXrCHHaIC9dE5L","plan":"UQkGjell16dyu0nlLHYN"};